import {RootState} from '../../store';
import {PaymentProfile} from './types';

export const selectionSelector = (state: RootState): Record<string, PaymentProfile> =>
    state['payment-profiles'].selection as Record<string, PaymentProfile>;
